module.exports = __webpack_public_path__ + "img/read-icon.b3181df8.svg";